module.exports = __webpack_public_path__ + "1c5226430ebda73f6aaa7fc0a985a9d6.png";